import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProjectsGridEditorial from "@/components/ProjectsGridEditorial";

export default function WorkIndex() {
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-bg text-black pt-[22vh] md:pt-[24vh] px-4 md:px-6 pb-10">
      <div className="font-mono uppercase text-[12px] tracking-[0.12em] text-muted2 mb-5">[ Work ]</div>
      <h1 className="font-display uppercase font-[900] tracking-[-0.02em] leading-[0.88] text-6xl sm:text-7xl lg:text-8xl mb-16 md:mb-24">
        All projects
      </h1>
      <ProjectsGridEditorial projects={projects} />
    </div>
  );
}
